import { utilService } from "./utilService";
import { apiService } from ".";
import { apiServiceConstants } from "../constants";

const getEMSAlertFromServer = async (): Promise<any> => {
  const params: any = {};
  const respApiResult = await apiService
    .apiCall(
      `ems/new-case-patients/?reg_code=${utilService.getNetwork()}&guid=${utilService.getLoggedUserGuid()}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService
        .getCurrentMinutes()
        .toString()}&date=${utilService.getCurrentDate()}&time_zone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const EMSAlertResp = res as any;
      const result: any = {
        isSuccess: true,
        result: EMSAlertResp.result,
        status: EMSAlertResp.status,
        message: EMSAlertResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getRejectPatientList = async (): Promise<any> => {
  const params: any = {};
  const respApiResult = await apiService
    .apiCall(
      `ems/rejected-case-patients/?reg_code=${utilService.getNetwork()}&guid=${utilService.getLoggedUserGuid()}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService
        .getCurrentMinutes()
        .toString()}&date=${utilService.getCurrentDate()}&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const EMSAlertResp = res as any;
      const result: any = {
        isSuccess: true,
        result: EMSAlertResp.result,
        status: EMSAlertResp.status,
        message: EMSAlertResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getProvidersList = async (): Promise<any> => {
  const params: any = {};
  const respApiResult = await apiService
    .apiCall(
      `ems/emergency-provider-alert/?reg_code=${utilService.getNetwork()}&guid=${utilService.getLoggedUserGuid()}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService
        .getCurrentMinutes()
        .toString()}&date=${utilService.getCurrentDate()}&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const EMSAlertResp = res as any;
      const result: any = {
        isSuccess: true,
        result: EMSAlertResp.result,
        status: EMSAlertResp.status,
        message: EMSAlertResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getCareTeamMembersList = async (): Promise<any> => {
  const params: any = {};
  const respApiResult = await apiService
    .apiCall(
      `ems/care-team-user-alert/?reg_code=${utilService.getNetwork()}&guid=${utilService.getLoggedUserGuid()}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService
        .getCurrentMinutes()
        .toString()}&date=${utilService.getCurrentDate()}&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const EMSAlertResp = res as any;
      const result: any = {
        isSuccess: true,
        result: EMSAlertResp.result,
        status: EMSAlertResp.status,
        message: EMSAlertResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

export const EMSAlertService = {
  getEMSAlertFromServer,
  getRejectPatientList,
  getProvidersList,
  getCareTeamMembersList,
};
